// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-spin-nested-loading > div .ant-spin {\n  max-height: 100%; }\n\n.Spin_wrapper__1of-n:not(.Spin_icon__1qK_D) {\n  position: fixed !important;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffffcc;\n  z-index: 1000;\n  flex-direction: column; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "Spin_wrapper__1of-n",
	"icon": "Spin_icon__1qK_D"
};
module.exports = exports;
